var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-privacy-policy.52a3eea4.png","uri@2x": __webpack_public_path__ + "icon-privacy-policy.60764d06.png","uri@3x": __webpack_public_path__ + "icon-privacy-policy.8ef32f63.png",
    width: 20,
    height: 20
});